/**
 * [Fecha formateada DD/MM/AAAA]
 * @param {string} date [fecha]
 */
export function dateFormat(date) {
  const formatted = date
    .toString()
    .slice(0, 10)
    .split("-")
    .reverse()
    .join("/");

  return formatted;
}

export function getHourFormat(date) {
  const hour = date.toString().slice(-8);

  return hour;
}

/**
 * Convierte una cantidad de segundos a formato HH:mm:ss
 * @param {number} seconds - Segundos a convertir
 * @returns {string} Tiempo formateado o cadena vacía si el input es inválido
 */
export function secondsToTimeFormat(seconds) {
  // 1. Validación: Verificamos que sea un número válido y no sea negativo
  if (typeof seconds !== "number" || isNaN(seconds) || seconds < 0) {
    console.log("Input inválido:", seconds);
    return "";
  }

  // 2. Cálculos matemáticos
  // Math.floor elimina los decimales
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  // 3. Formateo a dos dígitos (00:00:00)
  // String().padStart(2, '0') añade un cero a la izquierda si solo hay un dígito
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(secs).padStart(2, "0");

  const result = `${hh}:${mm}:${ss}`;

  console.log("Resultado del parseo:", result);
  return result;
}

/**
 * [HH:MM:SS formateado a 00h 00m 00s]
 * @param {string} seconds [segundos]
 */
export function HumanTimeFormat(time) {
  let result = time.split(":");

  result[0] = result[0] + "h";
  result[1] = result[1] + "m";
  result[2] = result[2] + "s";

  result = result.filter((value) => !value.startsWith("00"));

  return result.join(" ");
  // return result;
}

/**
 * [Segundos formateado a HH:MM:SS]
 * @param {string} seconds [segundos]
 */
export function secondsToHumanTimeFormat(seconds) {
  let date = new Date(null);
  date.setSeconds(seconds);
  let result = date.toISOString().substr(11, 8);

  return HumanTimeFormat(result);
}

// /**
//  * [MM:SS formateado a Segundos]
//  * @param {string} minutes [minutos HH:SS]
//  */
// export function HumanTimeFormatToSeconds(seconds) {
//   let date = new Date(null);
//   date.setSeconds(seconds);
//   let result = date.toISOString().substr(11, 8);

//   return HumanTimeFormat(result);
// }
